import type { FC } from 'react';
import type { Milestone } from '../types';
import type { SpecTerminateNodeChoice, TerminateMatrixCell, TerminateMatrixCol } from '../utils/terminateMatrix';
import { TerminateStatusMatrixModal } from './TerminateStatusMatrixModal';

export type ProjectTerminateSkuCol = TerminateMatrixCol;

type Props = {
  open: boolean;
  milestones: Milestone[];
  cols: TerminateMatrixCol[];
  cells: Record<string, TerminateMatrixCell>;
  confirmLoading?: boolean;
  onCancel: () => void;
  onConfirm: (payload: {
    reason: string;
    remark: string;
    nodeStatuses: {
      specId: number;
      ipdSkuId: number;
      milestoneId: number;
      status: SpecTerminateNodeChoice;
    }[];
  }) => void | Promise<void>;
};

/** 项目终止弹窗：多 SKU 规格按 SKU 分列 */
export const ProjectTerminateModal: FC<Props> = props => (
  <TerminateStatusMatrixModal selectionMode="project" {...props} />
);
